import {Autocomplete, TextField} from "@mui/material";
import React from "react";

export const BaseAutocomplete = ({
  value = null,
  onChangeValue,
  options,
  label,
}) => {
  const getOptionLabel = (option: {name: string}) => option.name
  return (
    <Autocomplete
      fullWidth
      value={value ? value : undefined}
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={(event, value: {id: string, name: string}) =>
        onChangeValue(value ? {id: value.id, name: value.name} : null)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              padding: '4px 8px',
              '& fieldset': {
                borderColor: 'rgb(47,115,145)',
              },

            },
          }}
          label={label}
        />
      )}
    />
  )
}